import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  TextField,
  CircularProgress,
  Typography,
} from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import { getOvertimeRequestByIdApi } from "app/redux/api/overtime";
import { updateOvertimeRequest } from "app/redux/actions/overtimeActions";
import { useAuth } from "app/hooks/useAuth";
import { toast } from "react-toastify";

const EditOvertimeRequest = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useAuth();
  const [formData, setFormData] = useState({ hours: "", reason: "" });
  const [employeeName, setEmployeeName] = useState("");
  const [loading, setLoading] = useState(true);

useEffect(() => {
    const fetchRequest = async () => {
      try {
        const res = await getOvertimeRequestByIdApi(id, token);
        if (res.data.succeeded) {
          const { hours, reason, User } = res.data.data;
          const overtimeMinutes = Math.round((hours || 0) * 60); 
          setFormData({ hours: overtimeMinutes, reason }); 
          setEmployeeName(User?.name || "N/A");
        } else {
          toast.error("Failed to fetch request details.");
          navigate(-1);
        }
      } catch (error) {
        toast.error("An error occurred.");
        navigate(-1);
      } finally {
        setLoading(false);
      }
    };
    fetchRequest();
  }, [id, token, navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
const handleSubmit = async (event) => {
    event.preventDefault();
    if (isNaN(formData.hours) || parseFloat(formData.hours) < 0) { 
      toast.error("Minutes must be a non-negative number.");
      return;
    }
    setLoading(true);
    try {
      const hoursInDecimal = parseFloat(formData.hours) / 60;

      await dispatch(
        updateOvertimeRequest(id, {
          reason: formData.reason,
          hours: hoursInDecimal, 
        })
      );
      navigate("/all-overtime-requests");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <SimpleCard>
      <Breadcrumb
        routeSegments={[
          { name: "All Overtime Requests", path: "/all-overtime-requests" },
          { name: "Edit Request" },
        ]}
      />
      <Typography variant="h5" sx={{ mb: 3 }}>
        Edit Overtime Request for {employeeName}
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 3 }}
      >
        <TextField
          name="hours"
          label="Overtime Hours"
          type="number"
          value={formData.hours}
          onChange={handleChange}
          fullWidth
          required
          inputProps={{ step: "0.01", min: "0" }}
        />
        <TextField
          name="reason"
          label="Reason"
          value={formData.reason}
          onChange={handleChange}
          fullWidth
          multiline
          rows={4}
          required
        />
        <Box
          sx={{ display: "flex", justifyContent: "flex-start", gap: 2, mt: 2 }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Save Changes"}
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            disabled={loading}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </SimpleCard>
  );
};

export default EditOvertimeRequest;
